export default "__VITE_ASSET__BsoMx3MT__"